$(document).ready(function(){
  $('.nav-item a:first').addClass('active');
  $('.tab-content div:first').addClass('show active');
  $('.carousel-inner div:first').addClass('active');
});

$("table > tbody").hide().slice(0, 10).show();
$(".show-all").on("click", function() {
  $("tbody > tr", $(this).prev()).show();
});